var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container home"},[_c('img',{staticClass:"profile rounded-circle mx-auto d-block",attrs:{"src":"/public/profile.jpg","alt":"andhikaribrahim: profile image"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('Jargon'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Skillset')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"ident":"vue-loader-options"}!./node_modules/vue-loader/lib?{"ident":"vue-loader-options"}!./src/Views/Home.vue?vue&type=template&id=4fb6dc72
// module id = 197
// module chunks = 0